import { motion } from "framer-motion";
import { FLAVOURS } from "@/data/content";
import { PRIZE_META } from "@/lib/game";

const GUMMIES = Array.from({ length: 12 }, (_, i) => ({ i, x: -70 + ((i * 47) % 140), d: 0.05 * i, s: 12 + (i % 3) * 4 }));
const TEAR = [[0, 8.6], [6, 8], [12, 9.1], [19, 8.3], [25, 9], [31, 8.1], [38, 8.9], [44, 8.2], [50, 9.2], [57, 8.3], [63, 8.8], [69, 8], [75, 9], [82, 8.2], [88, 9.1], [94, 8.3], [100, 8.7]];
const edge = TEAR.map(([x, y]) => `${x}% ${y}%`);
const JAG = `polygon(${edge.join(", ")}, 100% 100%, 0% 100%)`;
const TOP = `polygon(0% 0%, 100% 0%, ${[...edge].reverse().join(", ")})`;

export const PrizeCard = ({ k, small, testid }) => {
  const m = PRIZE_META[k] || PRIZE_META.pct10;
  return (
    <div data-testid={testid} className={`rounded-2xl text-[#1B1530] text-center shadow-xl border-2 border-[#1B1530] ${small ? "px-2 py-1.5" : "px-6 py-4"}`} style={{ background: m.color }}>
      <p className={`font-display leading-none ${small ? "text-sm" : "text-3xl sm:text-4xl"}`}>{m.title}</p>
      {!small && <p className="text-xs font-bold uppercase tracking-wider mt-1">{m.sub}</p>}
    </div>
  );
};

export const RipReveal = ({ pick, prize, others }) => {
  const f = FLAVOURS.find((x) => x.key === pick) || FLAVOURS[0];
  const rest = FLAVOURS.filter((x) => x.key !== f.key);
  return (
    <div data-testid="game-reveal" className="flex flex-col items-center">
      <div className="relative h-60 sm:h-72 w-full flex justify-center">
        <motion.div className="relative h-44 sm:h-52" initial={{ rotate: 0, y: 0 }} animate={{ rotate: [0, -6, 0, 135], y: [0, -6, 0, -20], x: [0, 0, 0, 40] }}
          transition={{ duration: 1.1, times: [0, 0.15, 0.4, 1], delay: 0.5, ease: "easeInOut" }}>
          <img src={f.img} alt={f.name} className="h-full w-auto" style={{ clipPath: JAG }} />
          <motion.img src={f.img} alt="" className="absolute inset-0 h-full w-auto" style={{ clipPath: TOP, transformOrigin: "0% 8.5%" }}
            initial={{ x: 0, y: 0, rotate: 0, opacity: 1 }} animate={{ rotate: [0, -10, -28], x: [0, 4, 90], y: [0, -4, -80], opacity: [1, 1, 0] }}
            transition={{ duration: 0.8, times: [0, 0.35, 1], delay: 0.3, ease: "easeOut" }} />
        </motion.div>
        {GUMMIES.map((g) => (
          <motion.span key={g.i} className="absolute rounded-[45%] top-16" style={{ width: g.s, height: g.s * 1.2, background: f.color, boxShadow: "inset -2px -3px 0 rgba(0,0,0,.15)" }}
            initial={{ opacity: 0, x: 40, y: 0 }} animate={{ opacity: [0, 1, 1], x: 40 + g.x, y: [0, 60, 170], rotate: g.i * 40 }}
            transition={{ duration: 0.9, delay: 1.25 + g.d, ease: "easeIn" }} />
        ))}
        <motion.div className="absolute bottom-0" initial={{ scale: 0, y: -60, rotate: -8 }} animate={{ scale: 1, y: 0, rotate: -3 }}
          transition={{ type: "spring", stiffness: 260, damping: 14, delay: 1.6 }}>
          <PrizeCard k={prize.key} testid="game-prize-card" />
        </motion.div>
      </div>
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 2.3 }} className="mt-5 w-full">
        <p className="text-center text-xs font-bold uppercase tracking-[0.2em] text-[#4A4560] mb-3">What was in the other bags</p>
        <div className="grid grid-cols-4 gap-2" data-testid="game-missed-prizes">
          {rest.map((b, i) => (
            <div key={b.key} className="flex flex-col items-center gap-1.5 opacity-70">
              <img src={b.img} alt="" className="h-12 sm:h-14 w-auto grayscale-[40%]" />
              <PrizeCard k={others?.[i]?.key} small />
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};
